<template>
  <span>
  <v-navigation-drawer app right class="drawer" v-model="drawer" dark>
     <v-list>
       <v-list-item router :to="{ name: 'Home', hash: '#services' }">
          <v-list-item-content>
            {{ $t('menuServices') }}
          </v-list-item-content>
      </v-list-item>
       <v-divider></v-divider>
      <v-list-item :to="{ name: 'Home', hash: '#about' }">
        <v-list-item-content>
            {{ $t('menuAbout') }}
        </v-list-item-content>
     </v-list-item>
       <v-divider></v-divider>
      <v-list-item :to="{ name: 'Home', hash: '#certificates' }">
           <v-list-item-content>
            {{ $t('menuCertificates') }}
          </v-list-item-content>
      </v-list-item>
       <v-divider></v-divider>
       <v-list-item :to="{ name: 'Home', hash: '#impact' }">
           <v-list-item-content>
            {{ $t('menuCharity') }}
          </v-list-item-content>
      </v-list-item>
       <v-divider></v-divider>
<!--      <v-list-item :to="{ name: 'Career' }">-->
<!--           <v-list-item-content>-->
<!--            {{ $t('menuCareer') }}-->
<!--          </v-list-item-content>-->
<!--      </v-list-item>-->
<!--       <v-divider></v-divider>-->
      <v-list-item :to="{ name: 'Home', hash: '#contact' }">
          <v-list-item-content>
            {{ $t('menuContact') }}
          </v-list-item-content>
      </v-list-item>
       <v-divider></v-divider>
      <v-list-item v-on:click="changeLanguage()">
          <v-list-item-content>
            {{ language }}
          </v-list-item-content>
      </v-list-item>
     </v-list>
  </v-navigation-drawer>
    <v-app-bar   app id="app-bar" fixed :color="dynamic" height="80px" v-scroll="onScroll">
      <router-link :to="{ name: 'Home', hash: '#home' }">
      <v-avatar class="mr-3" color="grey lighten-5" size="65">
        <v-img
            contain
            max-height="80%"
            src="../assets/logo-new.png"
        ></v-img>
      </v-avatar>
      </router-link>

      <router-link class="hidden-sm-and-down"  :to="{ name: 'Home', hash: '#home' }" tag="span">
        <v-toolbar-title class="font-weight-black headline">
          <span>{{ $t('startTitle') }}</span>
        </v-toolbar-title>
      </router-link>

      <v-spacer></v-spacer>
      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" :color="text_color"></v-app-bar-nav-icon>
      <v-btn class="hidden-sm-and-down" :color="text_color" text :to="{ name: 'Home', hash: '#services' }">
        <span>{{ $t('menuServices') }}</span>
      </v-btn>
      <v-btn class="hidden-sm-and-down" :color="text_color" text :to="{ name: 'Home', hash: '#about' }">
        <span>{{ $t('menuAbout') }}</span>
      </v-btn>
      <v-btn class="hidden-sm-and-down " :color="text_color" text :to="{ name: 'Home', hash: '#certificates' }">
        <span>{{ $t('menuCertificates') }}</span>
      </v-btn>
      <v-btn class="hidden-sm-and-down" :ripple="{ class: 'primary--text' }" :color="text_color" text :to="{ name: 'Home', hash: '#impact' }">
        <span>{{ $t('menuCharity') }}</span>
      </v-btn>
<!--      <v-btn class="hidden-sm-and-down" :color="text_color" text :to="{ name: 'Career' }">-->
<!--        <span>{{ $t('menuCareer') }}</span>-->
<!--      </v-btn>-->
      <v-btn class="hidden-sm-and-down" :color="text_color" text :to="{ name: 'Home', hash: '#contact' }">
        <span>{{ $t('menuContact') }}</span>
      </v-btn>
      <v-btn class="hidden-sm-and-down" :color="text_color" text v-on:click="changeLanguage()">
              <span>{{ language }}</span>
      </v-btn>
    </v-app-bar>
    </span>
</template>

<script>
import i18n from '@/plugins/i18n';


export default {
  data: () => ({
    language: i18n.locale,
    dynamic: "transparent",
    text_color: "black",
    drawer: false,
  }),
  methods: {
    onScroll() {
      console.log(this.dynamic);
      this.dynamic = "white";
      this.text_color = "black";
      if (window.scrollY == 0) {
        this.dynamic = "transparent";
        this.text_color = "black";
      }
    },
    changeLanguage() {
      if (i18n.locale == 'EN') {
        i18n.locale = 'DE';
      } else {
        i18n.locale = 'EN';
      }
      this.language = i18n.locale;
    },
  }
};
</script>

<style scoped>
.headline {
  color: white;
}
.drawer {
  opacity: 0.5;
}
</style>